(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["psc-hydra-home-options"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('psc-hydra-options')) return;
  class PSCHydraOptions extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.deadline = Date.now() + 20000;
      this.initialize();
    }

    disconnectedCallback() { clearTimeout(this.retry); }

    initialize() {
      if (!this.isConnected) return;
      const config = window.GPOConfigs;
      const setId = String(config?.productOptionSetMap?.[this.dataset.productId] || '');
      const optionSet = config?.options?.[setId];
      if (!optionSet || !config?.translations) {
        if (Date.now() < this.deadline) this.retry = setTimeout(() => this.initialize(), 150);
        else this.fail();
        return;
      }
      try {
        this.section = document.getElementById('shopify-section-' + this.dataset.sectionId);
        this.form = document.getElementById('product-form-' + this.dataset.sectionId);
        if (!this.section || !this.form) throw new Error('Missing product form');
        this.setId = setId;
        const flatten = elements => elements.flatMap(e => e.type === 'group' ? flatten(e.elements || []) : [e]);
        this.fields = flatten(optionSet.elements || []).filter(e => !e.hidden);
        const expected = ['dropdown-1', 'select-1', 'checkbox-1', 'checkbox-2', 'text-1', 'text-2'];
        if (this.fields.length !== expected.length || !expected.every(id => this.fields.some(e => e.id === id)) ||
            this.fields.some(e => !['dropdown', 'select', 'checkbox', 'text'].includes(e.type)) ||
            this.dataset.currency !== 'USD') throw new Error('Unsupported option configuration');
        for (const field of this.fields) {
          if (field.label_on_cart !== field.id) throw new Error('Changed cart fields');
          if (field.conditionalField && field.clo?.whens.some(rule => !['CONTAINS', 'EQUALS'].includes(rule.where))) throw new Error('Unsupported condition');
          for (const choice of field.option_values || []) {
            if (choice.variant_id || choice.product_handle || (choice.price && field.id !== 'dropdown-1')) {
              throw new Error('Unsupported add-on product');
            }
          }
        }
        this.money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency', currency: this.dataset.currency
        }).format(cents / 100);
        this.controls = new Map();
        this.hiddenFields = document.createElement('div');
        this.hiddenFields.dataset.pscHydraProperties = '';
        this.form.append(this.hiddenFields);
        this.fields.forEach(field => this.renderField(field));
        this.addEventListener('change', () => this.sync());
        this.addEventListener('input', () => this.sync());
        this.form.addEventListener('submit', event => {
          this.sync();
          if (!this.form.reportValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, true);
        this.sync();
        this.querySelector('[data-hydra-status]').hidden = true;
        this.querySelector('[data-hydra-fallback]').hidden = true;
        this.section.setAttribute('data-psc-hydra-ready', 'true');
      } catch (error) {
        console.warn('Hydra homepage options unavailable.', error);
        this.fail();
      }
    }

    fail() {
      this.querySelector('[data-hydra-fields]').replaceChildren();
      this.querySelector('[data-hydra-status]').textContent = this.dataset.error;
      this.section?.removeAttribute('data-psc-hydra-ready');
    }

    renderField(field) {
      const group = document.createElement(field.type === 'checkbox' ? 'fieldset' : 'div');
      group.className = 'psc-hydra-field';
      group.dataset.hydraField = field.id;
      const label = document.createElement(field.type === 'checkbox' ? 'legend' : 'label');
      const id = this.id + '-' + field.id;
      label.textContent = String(field.label || '').trim() + (field.required ? ' *' : '');
      if (field.type !== 'checkbox') label.htmlFor = id;
      group.append(label);
      const inputs = [];
      if (field.type === 'checkbox') {
        for (const [index, choice] of field.option_values.entries()) {
          const row = document.createElement('label');
          row.className = 'psc-hydra-choice';
          const input = document.createElement('input');
          input.type = 'checkbox';
          input.id = id + '-' + index;
          input.value = String(choice.value).trim();
          input.setAttribute('form', this.form.getAttribute('id')); 
          const text = document.createElement('span');
          text.textContent = input.value;
          row.append(input, text);
          group.append(row);
          inputs.push(input);
        }
      } else {
        const input = document.createElement(field.type === 'text' ? 'input' : 'select');
        input.id = id;
        input.setAttribute('form', this.form.getAttribute('id')); 
        if (field.type === 'text') {
          input.type = 'text';
          input.maxLength = 255;
        } else {
          input.add(new Option(field.placeholder || '-- Please select --', ''));
          for (const choice of field.option_values || []) {
            const price = Number(choice.price) || 0;
            input.add(new Option(String(choice.value).trim() + (price ? ' (+' + this.money(price * 100) + ')' : ''), String(choice.value).trim()));
          }
        }
        group.append(input);
        inputs.push(input);
      }
      this.controls.set(field.id, { field, group, inputs });
      this.querySelector('[data-hydra-fields]').append(group);
    }

    value(id) {
      const control = this.controls.get(id);
      if (!control || control.group.hidden) return '';
      return control.field.type === 'checkbox'
        ? control.inputs.filter(input => input.checked).map(input => input.value).join(', ')
        : control.inputs[0].value.trim();
    }

    sync() {
      const props = { _has_gpo: this.setId };
      for (const { field, group, inputs } of this.controls.values()) {
        let visible = true;
        if (field.conditionalField && field.clo) {
          const matches = field.clo.whens.map(rule => {
            const selected = this.value(rule.select).toLowerCase();
            const expected = String(rule.value).trim().toLowerCase();
            if (rule.where === 'CONTAINS') return selected.includes(expected);
            if (rule.where === 'EQUALS') return selected === expected;
            throw new Error('Unsupported Hydra condition');
          });
          const matched = field.clo.match === 'all' ? matches.every(Boolean) : matches.some(Boolean);
          visible = field.clo.display === 'hide' ? !matched : matched;
        }
        group.hidden = !visible;
        for (const input of inputs) {
          input.disabled = !visible;
          input.required = visible && field.required && field.type !== 'checkbox';
          input.setCustomValidity('');
          if (!visible) {
            if (input.type === 'checkbox') input.checked = false;
            else input.value = '';
          }
        }
        if (visible && field.type === 'checkbox') {
          const count = inputs.filter(input => input.checked).length;
          const max = Number(field.max) || 15;
          if (!count && field.required) inputs[0].setCustomValidity(this.dataset.required);
          else if (count > max) inputs[0].setCustomValidity(this.dataset.maxError.replace('__LIMIT__', String(max)));
        }
        if (visible && this.value(field.id)) props[field.label_on_cart] = this.value(field.id);
      }
      const preload = this.controls.get('dropdown-1').field;
      const selected = preload.option_values.find(choice => String(choice.value).trim() === this.value('dropdown-1'));
      const surcharge = Number(selected?.price) || 0;
      if (surcharge) {
        props._gpo_options = JSON.stringify(props);
        props._gpo_addon_products = JSON.stringify([{ i: Number(this.dataset.variantId), q: 1, p: String(surcharge), t: 'price' }]);
        props._gpo_product_group = this.groupId || (this.groupId = String(Date.now()));
      }
      this.hiddenFields.replaceChildren();
      for (const [name, value] of Object.entries(props)) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + name + ']';
        input.value = value;
        this.hiddenFields.append(input);
      }
      const price = this.money(Number(this.dataset.basePrice) + surcharge * 100) + ' ' + this.dataset.currency;
      this.section.querySelectorAll('.price__regular .price-item--regular').forEach(el => { el.textContent = price; });
    }
  }
  customElements.define('psc-hydra-options', PSCHydraOptions);
})();
  } catch(e) { console.error(e); }
})();

})();
